export default __webpack_public_path__ + "static/media/map1.e459170a.jpg";